import $ from 'cash-dom';


$(() => {
    let $body = $('body');

    $body.on('click', '.js-accordion-trigger', (e) => {
        e.preventDefault();
        let $item = $(e.currentTarget).closest('.js-accordion-item');
        let $content = $item.find('.js-accordion-target')[0];

        if (!$item.hasClass('active')) {
            $item.addClass('active');

            // quickly get the height we want to animate to
            $content.style.height = 'auto';
            var height = $content.clientHeight + 'px';

            // revert the heioght back to nothing
            $content.style.height = 0;

            // animate the height once the calculations are done
            setTimeout(function () {
                $content.style.height = height;
            }, 0);
        } else {
            $item.removeClass('active');

            // revert the height back to nothing
            $content.style.height = 0;

            // remove the active class once animations are over
            $content.addEventListener('transitionend', function () {
                $item.removeClass('active');
            }, { once: true });


        }

    });

});
